import { useState } from "react";

import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";

import "./cardPrestataireV2.css";
import "./cardPrestataireV2-share.css";

import {

    faStar,

    faLocationDot,

    faComment,

    faFileLines,

    faXmark,

    faEnvelope,

    faPhone,

    faMagnifyingGlass,

    faGlobe,
    faShareNodes,
    faCopy,

} from "@fortawesome/free-solid-svg-icons";



import imgCesu from "../../assets/cesu.png";



const CardPrestataireV2 = ({ prestataire }) => {

    const apiUrl = process.env.REACT_APP_API_URL;



    const [showDescriptionModal, setShowDescriptionModal] = useState(false);

    const [showContactModal, setShowContactModal] = useState(false);
    const [showShareModal, setShowShareModal] = useState(false);
    const [linkCopied, setLinkCopied] = useState(false);

    // Partage le lien de la page courante, accompagné du nom du prestataire.
    // Pour un lien direct vers la fiche, remplacez shareUrl par l'URL de détail
    // construite à partir de la route/identifiant utilisé par votre application.
    const shareUrl = typeof window !== "undefined" ? window.location.href+"presta/"+prestataire.idPrestataire : "";
    const shareTitle = `Découvrez ${prestataire.raisonSocialePrestataire || "ce prestataire"}`;
    const shareText = `${shareTitle}${prestataire.villePrestataire ? ` à ${prestataire.villePrestataire}` : ""}`;

    const encodedUrl = encodeURIComponent(shareUrl);
    const encodedText = encodeURIComponent(`${shareText} : ${shareUrl}`);

    const copyShareLink = async () => {
        try {
            await navigator.clipboard.writeText(shareUrl);
            setLinkCopied(true);
            window.setTimeout(() => setLinkCopied(false), 2000);
        } catch {
            window.prompt("Copiez le lien de partage :", shareUrl);
        }
    };



    const closeModals = () => {

        setShowDescriptionModal(false);

        setShowContactModal(false);
        setShowShareModal(false);

    };



    return (

        <>

            <div className="card-prestaV2">



                {prestataire.isCesuAccepted && (

                    <div

                        style={{

                            position: "absolute",

                            left: 0,

                            top: 0,

                        }}

                    >

                        <img

                            src={imgCesu}

                            alt="icon cesu"

                            width={80}

                            height={80}

                        />

                    </div>

                )}



                <div className="logo-presta">

                    <img

                        src={

                            prestataire.logoPrestataire

                                ? apiUrl +

                                  "/api/files/?categorie=logos&file=" +

                                  prestataire.logoPrestataire

                                : prestataire.photoProfilPrestataire

                                ? `${apiUrl}/api/files/?categorie=photosPrestataires&file=${prestataire.photoProfilPrestataire}`

                                : apiUrl +

                                  "/api/files/?categorie=metiers&file=" +

                                  prestataire.competences?.[0]?.iconMetier

                        }

                        alt="logo ou image profil"

                    />

                </div>



                <div className="inner-card">



                    <div>

                        <h3 style={{ color: "blue" }}>

                            <FontAwesomeIcon

                                icon={faLocationDot}

                                style={{ marginRight: "15px" }}

                            />

                            {prestataire.villePrestataire}

                        </h3>



                        <h3>

                            {prestataire.raisonSocialePrestataire}

                        </h3>

                    </div>



                    <div className="separator"></div>



                    <div>

                        <p className="infos-presta">

                            <span className="presta-name">

                                {prestataire.firstNamePrestataire}

                            </span>



                            <span className="presta-note">

                                <FontAwesomeIcon

                                    icon={faStar}

                                    className="star"

                                />

                                {" "}5 (50)

                            </span>

                        </p>



                        {prestataire.competences &&

                            prestataire.competences.map((comp) => (

                                <p

                                    key={comp.idMetier}

                                    className="job"

                                >

                                    {comp.labelMetier}

                                </p>

                            ))}

                    </div>




                    <button

                        className="contact-button"

                        onClick={() => setShowContactModal(true)}



                    >

                        <FontAwesomeIcon icon={faComment} />

                        <span>Contacter</span>

                    </button>




                    <button

                        onClick={() =>

                            setShowDescriptionModal(true)

                        }

                        className="fiche-button"

                    >

                        <FontAwesomeIcon icon={faFileLines} />

                        <span>Fiche prestataire</span>

                    </button>



                    {/* PARTAGER */}
                    <button
                        type="button"
                        className="share-button"
                        onClick={() => setShowShareModal(true)}
                    >
                        <FontAwesomeIcon icon={faShareNodes} />
                        <span>Partager ce prestataire</span>
                    </button>

                    {prestataire.siretPrestataire && (

                        <a

                            href={`https://www\.societe.com/cgi-bin/search?champs=${prestataire.siretPrestataire}`}

                            target="_blank"

                            rel="noopener noreferrer"

                            className="siret-button"

                        >

                            <FontAwesomeIcon icon={faMagnifyingGlass}/> <span>Vérifier le SIRET</span>

                        </a>

                    )}

                </div>

            </div>



            

            {showDescriptionModal && (

                <div

                    className="presta-modal-overlay"

                    onClick={closeModals}

                >

                    <div

                        className="presta-modal"

                        onClick={(e) => e.stopPropagation()}

                    >

                        <button

                            type="button"

                            className="presta-modal-close"

                            onClick={closeModals}

                        >

                            <FontAwesomeIcon icon={faXmark} />

                        </button>



                        <h2>

                            Fiche prestataire

                        </h2>



                        <h3>

                            {prestataire.raisonSocialePrestataire}

                        </h3>



                        <div className="presta-modal-content">



                            <h4>

                                Présentation

                            </h4>



                            <p>

                                {prestataire.descriptionPrestataire ||

                                    "Aucune description renseignée."}

                            </p>



                            <h4>

                                Localisation

                            </h4>



                            <p>

                                {prestataire.villePrestataire}

                            </p>



                            <h4>

                                Métiers

                            </h4>



                            {prestataire.competences?.length > 0 ? (

                                <div className="modal-competences">

                                    {prestataire.competences.map(

                                        (comp) => (

                                            <span

                                                key={comp.idMetier}

                                                className="modal-metier"

                                            >

                                                {comp.labelMetier}

                                            </span>

                                        )

                                    )}

                                </div>

                            ) : (

                                <p>

                                    Aucun métier renseigné.

                                </p>

                            )}

                        </div>

                    </div>

                </div>

            )}



            



            {showContactModal && (

                <div

                    className="presta-modal-overlay"

                    onClick={closeModals}

                >

                    <div

                        className="presta-modal contact-modal"

                        onClick={(e) => e.stopPropagation()}

                    >

                        <button

                            type="button"

                            className="presta-modal-close"

                            onClick={closeModals}

                        >

                            <FontAwesomeIcon icon={faXmark} />

                        </button>



                        <h2>

                            Contacter le prestataire

                        </h2>



                        <h3>

                            {prestataire.raisonSocialePrestataire}

                        </h3>



                        <div className="contact-modal-content">




                            {prestataire.mailPrestataire && (

                                <div className="contact-item">

                                    <FontAwesomeIcon

                                        icon={faEnvelope}

                                    />



                                    <div>

                                        <strong>Email</strong>



                                        <a

                                            href={`mailto:${prestataire.mailPrestataire}`}

                                        >

                                            {prestataire.mailPrestataire}

                                        </a>

                                    </div>

                                </div>

                            )}




                            {prestataire.telephonePrestataire && (

                                <div className="contact-item">

                                    <FontAwesomeIcon

                                        icon={faPhone}

                                    />



                                    <div>

                                        <strong>

                                            Téléphone

                                        </strong>



                                        <a

                                            href={`tel:${prestataire.telephonePrestataire}`}

                                        >

                                            {

                                                prestataire.telephonePrestataire

                                            }

                                        </a>

                                    </div>

                                </div>

                            )}

                            {prestataire.siteWeb && (

                                <div className="contact-item">

                                    <FontAwesomeIcon

                                        icon={faGlobe}

                                    />



                                    <div>

                                        <strong>

                                            Site web

                                        </strong>



                                        <a

                                            href={prestataire.siteWeb}

                                            target="_blank"

                                            rel="noopener noreferrer"

                                        >

                                            {

                                                prestataire.siteWeb

                                            }

                                        </a>

                                    </div>

                                </div>

                            )}

                            {!prestataire.emailPrestataire &&

                                !prestataire.telephonePrestataire && !prestataire.siteWeb && (

                                    <p>

                                        Aucune information de

                                        contact disponible.

                                    </p>

                                )}

                        </div>

                    </div>

                </div>

            )}

            {/* =====================================================
                MODALE PARTAGE
            ===================================================== */}
            {showShareModal && (
                <div className="presta-modal-overlay" onClick={closeModals}>
                    <div
                        className="presta-modal share-modal"
                        onClick={(e) => e.stopPropagation()}
                        role="dialog"
                        aria-modal="true"
                        aria-labelledby="share-modal-title"
                    >
                        <button type="button" className="presta-modal-close" onClick={closeModals} aria-label="Fermer">
                            <FontAwesomeIcon icon={faXmark} />
                        </button>
                        <h2 id="share-modal-title">Partager ce prestataire</h2>
                        <h3>{prestataire.raisonSocialePrestataire}</h3>
                        <p className="share-description">
                            Partagez cette adresse avec vos proches ou vos contacts.
                        </p>
                        <div className="share-options">
                            <a className="share-option share-whatsapp" href={`https://wa.me/?text=${encodedText}`} target="_blank" rel="noopener noreferrer">
                                <span className="share-option-icon" aria-hidden="true">◉</span><span>WhatsApp</span>
                            </a>
                            <a className="share-option share-facebook" href={`https://www.facebook.com/sharer/sharer.php?u=${encodedUrl}`} target="_blank" rel="noopener noreferrer">
                                <span className="share-option-icon" aria-hidden="true">f</span><span>Facebook</span>
                            </a>
                            <a className="share-option share-messenger" href={`https://www.facebook.com/dialog/send?link=${encodedUrl}&app_id=966242223397117&redirect_uri=${encodedUrl}`} target="_blank" rel="noopener noreferrer">
                                <span className="share-option-icon" aria-hidden="true">➤</span><span>Messenger</span>
                            </a>
                            <a className="share-option share-email" href={`mailto:?subject=${encodeURIComponent(shareTitle)}&body=${encodedText}`}>
                                <FontAwesomeIcon icon={faEnvelope} className="share-option-icon" /><span>E-mail</span>
                            </a>
                            <a className="share-option share-sms" href={`sms:?body=${encodedText}`}>
                                <FontAwesomeIcon icon={faComment} className="share-option-icon" /><span>SMS</span>
                            </a>
                            <button type="button" className="share-option share-copy" onClick={copyShareLink}>
                                <FontAwesomeIcon icon={faCopy} className="share-option-icon" /><span>{linkCopied ? "Lien copié !" : "Copier le lien"}</span>
                            </button>
                        </div>
                        {typeof navigator !== "undefined" && navigator.share && (
                            <button type="button" className="share-native-button" onClick={async () => {
                                try {
                                    await navigator.share({ title: shareTitle, text: shareText, url: shareUrl });
                                } catch (error) {
                                    if (error?.name !== "AbortError") console.error("Échec du partage natif :", error);
                                }
                            }}>
                                <FontAwesomeIcon icon={faShareNodes} /> Autres options de partage
                            </button>
                        )}
                    </div>
                </div>
            )}
        </>

    );

};



export default CardPrestataireV2;